export const lightTheme = {
    body: 'linear-gradient(90deg, rgba(244,244,255,0.5) 0%, rgba(203,208,233,0.4) 50%, rgba(244,244,255,0.5) 100%)',
    text: '#363537',
    toggleBorder: '#FFF',
    background: 'linear-gradient(90deg, rgba(244,244,255,0.5) 0%, rgba(203,208,233,0.4) 50%, rgba(244,244,255,0.5) 100%)',
    card: 'rgba(255,255,255,0.9)',
    subtleText: 'rgba(0,0,0,0.72)',
    accent: '#7C3AED',
    inputBorder: 'rgba(0,0,0,0.12)',
    inputBackground: 'rgba(255,255,255,0.98)',
    buttonGradient: 'linear-gradient(90deg,#2563eb,#7c3aed)'
}
export const darkTheme = {
    body: 'linear-gradient(90deg, rgba(31,31,31,1) 0%, rgba(77,77,81,1) 50%, rgba(31,31,31,1) 100%);',
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    background: 'linear-gradient(90deg, rgba(31,31,31,1) 0%, rgba(77,77,81,1) 50%, rgba(31,31,31,1) 100%);',
    card: '#071025',
    subtleText: 'rgba(255,255,255,0.78)',
    accent: '#aef1fa',
    inputBorder: 'rgba(255,255,255,0.06)',
    inputBackground: 'rgba(255,255,255,0.02)',
    buttonGradient: 'linear-gradient(90deg,#ff8a00,#e52e71)'
}